import { Injectable } from '@angular/core';
import { ScreenSizeState } from '@app/models/shared/screen-size-state';
import { TenantBranding } from '@app/models/TenantBranding';
import { map, Observable } from 'rxjs';
import { ConfigurationService } from '@app/app-initialisers/configuration-service/configuration.service';
import { VisualAssetType } from '@app/models/shared/visual-asset-type';
import { VisualAsset } from '@app/models/shared/visual-asset';
import { AndroWebCoreComponent } from '@app/core/AndroWebCoreComponent';

@Injectable({
  providedIn: 'root'
})
export class BackgroundImageService extends AndroWebCoreComponent {
  private _branding: TenantBranding;

  constructor(
    protected _configurationService: ConfigurationService
  ) {
    super();
    this._branding = this._configurationService.tenant?.Branding;
  }

  public getBackgroundImage(landscapeType: VisualAssetType, portraitType: VisualAssetType, fallback?: string): Observable<string> {
    return this._screenSizeService.screenSizeState$.pipe(
        map((state: ScreenSizeState) => {
          const getFirstSliceUrl = (assetType: VisualAssetType) => {
            const asset = this._branding?.VisualAssets?.find((x: VisualAsset) => x.Type === assetType);
            return this.queryMediaImage(asset?.Slices[0]?.Url, state);
          };
          const getLandscapeAsset = () => getFirstSliceUrl(landscapeType);
          const getPortraitAsset = () => getFirstSliceUrl(portraitType);
          return (state.isLandscape ? getLandscapeAsset() : getPortraitAsset()) ?? fallback;
        })
    );
  }
}
